import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { FileUploadAwsResponse, FileUploadResponse } from "../interfaces/form-model";

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(private http: HttpClient) { }

  upload(file: File): Observable<FileUploadResponse> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<FileUploadResponse>(`${window.location.origin}/ui-forms/v1/form/submitFileUpload`, formData);
  }

  uploadAws(file: File, fieldKey: string, uuId: string): Observable<FileUploadAwsResponse> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<FileUploadAwsResponse>(`${window.location.origin}/ui-forms/v1/form/submitFileUploadAws/${fieldKey}?uuid=${uuId}`, formData);
  }

  delete(fileId: string, uuId: string) {
    return this.http.delete(`${window.location.origin}/ui-forms/v1/form/submitFileUploadAws/${fileId}?uuid=${uuId}`);
  }
}
